import {Location} from '@angular/common';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {AnnouncementsService} from '../../../services/announcements.service';
import {CommonService} from '../../../services/common.service';
import {NotificationService} from '../../../services/notification.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

@Component({
  selector: 'app-consent-form',
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.scss']
})
export class ConsentFormComponent implements OnInit {

  // tslint:disable-next-line:variable-name
  // tslint:disable-next-line:variable-name
  // tslint:disable-next-line:variable-name
  @ViewChild('divElement', {static: false}) divElement: ElementRef;
  childBirthday: any;
  childDisplayName: any;
  childId: number;
  childInfo: any;
  code = '';
  commentArea: boolean;
  comments: string;
  consent1: boolean;
  consent2: boolean;
  consent3: boolean;
  consentQuestions = [];
  consentSliderItems: any;
  consentTypeId: number;
  contentWidth: any;
  editorStylePreview: any;
  formId: number;
  hasDeadline: boolean;
  hasForeignLanguage: any;
  hasMaxSlots: any;
  // tslint:disable-next-line:variable-name
  has_full_info: boolean;
  // tslint:disable-next-line:variable-name
  has_two_factor: boolean;
  htmlContent = '';
  isExternal: boolean;
  isOpened: number;
  languageLevels: any;
  languages: any;
  maxSlots: any;
  mode: string;
  notificationId: number;
  parentDisplayName: any;
  parentId: number;
  parentInfo: any;
  public form: any;
  public info: any;
  public isLoading: boolean;
  public jsonSObject: any;
  public loadedSate: boolean;
  requiresConsent: boolean;
  selectedLanguage: any;
  showTwoFactor = false;
  specificDate: any;
  // tslint:disable-next-line:variable-name
  unique_id: string;
  formTitle: string;

  constructor(private route: ActivatedRoute,
              private commonService: CommonService,
              private notificationService: NotificationService,
              private announcementsService: AnnouncementsService,
              public location: Location,
              public router: Router,
              public dialog: MatDialog,
              public toastMessagesService: ToastMessagesService) {
    this.isExternal = false;
    this.contentWidth = `width: ${window.innerWidth / 2}px`;
    this.loadedSate = false;
    this.isLoading = true;
    this.editorStylePreview = {width: '100%', height: '100%;', border: '0px'};

    this.consent1 = false;
    this.consent2 = false;
    this.consent3 = false;

    this.consentSliderItems = [];
    this.commentArea = false;

    this.has_full_info = true;
    this.languageLevels = [{id: 1, level: 'Κανένα'}, {id: 2, level: 'Αρχάριος'}, {id: 3, level: 'Μεσαίο'}, {
      id: 4,
      level: 'Proficiency'
    }];

  }

  async ngOnInit() {
    this.comments = '';
    this.route.queryParams.subscribe(async (params) => {
      this.unique_id = params.unique_id;
      this.isExternal = params.external ? params.external === 'true' : false;
      if (params.parentId) {
        await this.initParent(+params.parentId);
        this.parentId = +params.parentId;
      }

      if (params.childId) {
        await this.initChild(+params.childId);
        this.childId = +params.childId;
      }

      this.notificationId = +params.notificationId;

      this.mode = params.mode;
      await this.initializeForm();
      if (this.mode !== 'display') {
        await this.initConsents();
      } else {
        this.consentQuestions = this.consentSliderItems;
      }


      this.isOpened = +params.is_opened;
      if (this.isOpened === 0) {
        await this.updateAnnouncementAsSeen();
      }
    });
  }

  async updateAnnouncementAsSeen() {
    console.log('updating as seen');
    try {
      const model = {
        childId: this.childId,
        uniqueId: this.unique_id,
        is_opened: this.isOpened
      };
      await this.announcementsService.updateAnnouncementAsSeen(model);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('');
    }
  }

  async initConsents() {
    try {
      // tslint:disable-next-line:max-line-length
      const consentQuestionsRequest: any = await this.commonService.getList(`consents?userId=${this.parentId}&child_id=${this.childId}&form_id=${this.formId}`);
      for (const consent of consentQuestionsRequest.object) {
        consent.consentValue = consent && consent.consentValue === 1;
      }
      this.consentQuestions = consentQuestionsRequest.object;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  // initialize Parent's Info
  async initParent(id: number) {
    try {
      const result = await this.commonService.getList(`people/parent?id=${id}`);
      this.parentInfo = result.object[0];
      this.parentInfo.displayName = `${this.parentInfo.first_name} ${this.parentInfo.last_name}`;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  // initialize Child's Info
  async initChild(id: number) {
    try {
      const result = await this.commonService.getList(`people/student?id=${id}`);
      this.childInfo = result.object[0];
      this.childInfo.displayName = `${this.childInfo.firstName} ${this.childInfo.lastName}`;

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initializeForm() {
    try {

      const contentRequest = await this.commonService.getList(`forms?unique_id=${this.unique_id}`);
      this.jsonSObject = JSON.parse(contentRequest.object[0].content);
      this.formTitle = contentRequest.object[0].title || this.jsonSObject.title || '';

      this.commentArea = this.jsonSObject.commentArea === true;

      this.requiresConsent = this.jsonSObject.requiresConsent;
      this.formId = contentRequest.object[0].id;
      this.has_full_info = contentRequest.object[0].has_full_info === 1;
      this.hasDeadline = contentRequest.object[0].has_deadline === 1;
      this.hasForeignLanguage = contentRequest.object[0].has_foreign_language === 1;
      this.hasMaxSlots = contentRequest.object[0].has_max_slots === 1;
      this.maxSlots = contentRequest.object[0].max_slots;
      this.has_two_factor = contentRequest.object[0].has_two_factor === 1;

      if (this.hasForeignLanguage) {
        await this.initLanguages();
        const tempLanguages = this.languages.filter(language => language.id === contentRequest.object[0].language_id);
        console.log(tempLanguages);
        this.selectedLanguage = tempLanguages[0];
      }
      this.specificDate = contentRequest.object[0].deadline_date;
      this.consentSliderItems = this.jsonSObject.consentFields.filter(field => field.type === 'slider');
      for (const item of this.consentSliderItems) {
        item.consentDescription = item.title;
      }

      for (const item of this.consentSliderItems) {
        item.value = item.value === 'true';
      }

      // this.renderer.setProperty(this.divElement.nativeElement, 'innerHTML', this.jsonSObject.htmlContent);
      this.htmlContent = this.jsonSObject.htmlContent;
      this.loadedSate = true;
      this.isLoading = false;
    } catch (e) {
      console.log(e.message);
    }
  }

  async initLanguages() {
    try {
      const questionsRequest = await this.commonService.getList('languages');
      this.languages = questionsRequest.object;
    } catch (e) {
      console.log(e.message);
    }
  }

  async submitConsent() {
    if (this.has_two_factor) {
      this.showTwoFactor = true;
      await this.requestCode();
    } else {
      await this.finalizeConsent();
    }
  }

  async finalizeConsent() {
    const model = {
      notificationId: 0,
      formId: 0,
      parentId: 0,
      childId: 0,
      formUniqueId: '',
      consents: []
    };
    try {
      model.notificationId = this.notificationId;
      model.formId = this.formId;
      model.parentId = this.parentId;
      model.childId = this.childId;
      model.formUniqueId = this.unique_id;

      for (const consent of this.consentQuestions) {
        const consentModel = {
          id: consent.questionId,
          consentId: consent.id,
          value: consent.consentValue === -1 ? false : consent.consentValue,
          token: consent.unique_token
        };
        model.consents.push(consentModel);
      }

      await this.commonService.updateItem(`consents`, model);
      await this.notificationService.getAllNotifications(+this.parentId, true);
      if (this.isExternal) {
        await this.router.navigate(['success']);
      } else {
        await this.navigateBack();
      }
    } catch (e) {
      console.log(e.message);
    }
  }

  navigateBack() {
    this.location.back();
  }

  consentChange(item: any, event: any) {
    item.consentValue = event.checked;
  }

  getParentInfo(parameter: string) {
    if (this.parentInfo && this.parentInfo.hasOwnProperty(parameter)) {
      return this.parentInfo[parameter];
    } else {
      return '';
    }
  }

  getChildInfo(parameter: string) {
    if (this.childInfo && this.childInfo.hasOwnProperty(parameter)) {
      return this.childInfo[parameter];
    } else {
      return '';
    }
  }

  async requestCode() {
    const model = {
      mode: 'consent',
      submitPressed: new Date(),
      userId: this.parentId,
      consents: this.consentQuestions,
      childId: this.childId,
      formId: this.formId
    };
    try {
      console.log('requesting code');
      // tslint:disable-next-line:max-line-length
      const response: any = await this.commonService.updateItem(`twoStep/consents?parentId=${this.parentId}`, {
        childId: this.childId,
        formId: this.formId,
        consentQuestions: this.consentQuestions
      });
      console.log(response);
      console.log(response.object);
      this.toastMessagesService.toastMessages(response.object.message);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async validateCode() {
    try {
      const response = await this.submitTwoFactorCode();

      if (response && response.status === 200) {
        await this.finalizeConsent();
      } else {
        this.toastMessagesService.toastErrorMessage('Ο κωδικός που πληκτρολογήσατε δεν είναι σωστός');
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(`Ο κωδικός που πληκτρολογήσατε δεν είναι σωστός`);
    } finally {

    }
  }

  async submitTwoFactorCode() {
    try {
      const response: any = await this.commonService.insertItem(`twoStep/consents/authStep`, {
        userId: this.parentId,
        securityNumber: this.code,
        consents: this.consentQuestions,
        childId: this.childId,
        formId: this.formId
      });
      return response;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  editorCreated($event: any, value) {
    $event.root.innerHTML = value;
  }
}
